import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { FilterWrapper } from "./Style";
import FilterBox from "../../../../components/common/FilterBox";

const Filter = ({ onFilter }) => {
  const firstRun = React.useRef(true);

  const [filterValues, setFilterValues] = useState({
    cardProductNameFilter: "",
    binFilter: "",
    productIdFilter: "",
  });
  const [debounceTimer, setDebounceTimer] = useState(null);

  const filterForm = [
    {
      name: "cardProductNameFilter",
      type: "text",
      placeholder: "Search by Card Product Name",
      value: filterValues.cardProductNameFilter,
    },
    {
      name: "binFilter",
      type: "text",
      placeholder: "Search by Bin Number",
      value: filterValues.binFilter,
    },
    {
      name: "productIdFilter",
      type: "text",
      placeholder: "Search by Product Code",
      value: filterValues.productIdFilter,
    },
  ];

  // Debounce API call
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return; // ⛔ skip first auto-call
    }
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    const timer = setTimeout(() => {
      if (onFilter) {
        onFilter({
          cardProductName: filterValues.cardProductNameFilter?.trim() || null,
          bin: filterValues.binFilter?.trim() || null,
          productId: filterValues.productIdFilter?.trim() || null,
          pageNo: 0,
          pageSize: 10,
        });
      }
    }, 800);

    setDebounceTimer(timer);

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [filterValues, onFilter]);

  return (
    <div>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}
      >
        <FilterWrapper>
          <FilterBox
            filterForm={filterForm}
            onFilterChange={(e, index) => {
              const { value } = e.target;
              setFilterValues((prev) => ({
                ...prev,
                [filterForm[index].name]: value,
              }));
            }}
            onFilterSubmit={(e) => e.preventDefault()}
            className="transactionfilter"
            buttonValue=""
          />
        </FilterWrapper>
      </Box>
    </div>
  );
};

export default Filter;
